module.exports = __webpack_public_path__ + "img/14.99a8c36b.jpg";